import IndexPage from "./IndexPage"
import NotFoundPage from "./NotFoundPage"

// Register all site page routes at once using an object
export default {
  "/": IndexPage,
  "/404": NotFoundPage,
}